const steps = [
  {
    n: "01",
    title: "Prise de contact",
    desc: "Premier échange pour comprendre votre projet, vos contraintes et votre calendrier.",
  },
  {
    n: "02",
    title: "Analyse du projet",
    desc: "Étude de faisabilité, vérification PLU, identification des points de vigilance.",
  },
  {
    n: "03",
    title: "Réalisation de l'étude",
    desc: "Sondages géotechniques (G1 à G5), étude SPANC et plans architecturaux.",
  },
  {
    n: "04",
    title: "Création du dossier",
    desc: "Montage administratif complet : pièces, CERFA, notices, insertion paysagère.",
  },
  {
    n: "05",
    title: "Livraison & dépôt",
    desc: "Dépôt en mairie, suivi d'instruction et réponses aux demandes complémentaires.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-24 md:py-32 bg-secondary border-y border-border"
    >
      <div className="container-wide">
        <div className="grid md:grid-cols-12 gap-10 items-end mb-16">
          <div className="md:col-span-7 reveal">
            <div className="flex items-center gap-3 mb-6">
              <span className="rule" />
              <span className="overline">Déroulé</span>
            </div>
            <h2 className="text-4xl sm:text-5xl font-medium leading-tight text-primary">
              Comment{" "}
              <span className="italic font-light">ça se passe</span> ?
            </h2>
          </div>
          <div className="md:col-span-5 reveal">
            <p className="text-base text-muted-foreground">
              Un parcours en cinq étapes, maîtrisé de bout en bout. Chaque
              jalon est validé avec vous avant de passer au suivant.
            </p>
          </div>
        </div>

        <ol className="relative grid gap-6 md:grid-cols-2 lg:grid-cols-5">
          {steps.map((s, i) => (
            <li
              key={s.n}
              data-testid={`process-step-${i}`}
              className="reveal group relative bg-white border border-border p-7 hover:-translate-y-1 transition-all duration-300 hover:border-[hsl(var(--brand-terra))]"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="flex items-baseline justify-between mb-6">
                <span className="font-display text-5xl text-primary/20 group-hover:text-[hsl(var(--brand-terra))] transition-colors">
                  {s.n}
                </span>
                <span className="h-px w-10 bg-[hsl(var(--brand-terra))]" />
              </div>
              <h3 className="font-display text-xl text-primary leading-snug">
                {s.title}
              </h3>
              <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
                {s.desc}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
